import { OnInit } from '@angular/core';
import { Component } from '@angular/core';
import { NgIf, NgFor, DecimalPipe } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { maskitoTransform } from '@maskito/core';
import { MatButton } from '@angular/material/button';
import { MatFabButton } from '@angular/material/button';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { TabelaComponent } from '../../shared/tabela/tabela.component';
import { mask_porcetagem, mask_dinheiro } from '../../directives/mascaras';
import { LayoutEditorContentService, IconeAtivo } from '../../layouts/layout-editor/layout-editor-content.service';
import { MemoriaDeCalculoRequestDto } from '../../dtos/memoria-calculo-dto'
import {
  MemoriaDeCalculoDto,
  DadoFinanceiroDto,
  DadosEstatisticosDto,
  FuncionarioPorAreaAtuacaoDto
} from '../../dtos';
import {
  CondicaoQualidadeStateService,
  AcessoOfertaEducacionalStateService,
  MemoriaDeCalculoService,
  DadoFinanceiroService,
  DadosEstatisticosService,
  FuncionariosPorAreaAtuacaoService
} from '../../services';
import { PrecoEncargosAdicionaisStateService } from '../../services/preco-encargos-adicionais-state/preco-encargos-adicionais-state.service';
import { LocalizacaoService } from '../../services/localizacao/localizacao.service';
import { LayoutResultadoService } from '../../layouts/layout-resultado/layout-resultado.service';
import { LayoutEdicaoService } from '../../layouts/layout-edicao/layout-edicao.service';
import { Router } from '@angular/router';
import { FeatureFlagService } from '../../services/feature-flag/feature-flag.service';

@Component({
  selector: 'app-resultado-previsao-orcamentaria',
  standalone: true,
  imports: [
    NgIf,
    NgFor,
    TabelaComponent,
    MatIcon,
    MatFabButton,
    MatButton,
    RouterLinkActive,
    RouterLink,
    DecimalPipe,
  ],
  templateUrl: './resultado-previsao-orcamentaria.component.html',
  styleUrl: './resultado-previsao-orcamentaria.component.scss',
})
export class ResultadoPrevisaoOrcamentariaComponent implements OnInit {
  public dadosFinanceiros: DadoFinanceiroDto[] | undefined = undefined;
  public memoriaDeCalculo: MemoriaDeCalculoDto | undefined = undefined;
  public dadosEstatisticos: DadosEstatisticosDto | undefined = undefined;
  public funcionariosPorAreaAtuacao:
    | FuncionarioPorAreaAtuacaoDto[]
    | undefined = undefined;
  public memoriaDeCalculoRequest: MemoriaDeCalculoRequestDto | undefined =
    undefined;

  constructor(
    private dadoFinanceiroService: DadoFinanceiroService,
    private memoriaDeCalculoService: MemoriaDeCalculoService,
    private dadosEstatisticosService: DadosEstatisticosService,
    private layoutEditorContentService: LayoutEditorContentService,
    private condicaoQualidadeStateService: CondicaoQualidadeStateService,
    private precoEncargosAdicionaisStateService: PrecoEncargosAdicionaisStateService,
    private funcionariosPorAreaAtuacaoService: FuncionariosPorAreaAtuacaoService,
    private acessoOfertaEducacionalStateService: AcessoOfertaEducacionalStateService,
    private localizacaoService: LocalizacaoService,
    private layoutResultadoService: LayoutResultadoService,
    private layoutEdicaoService: LayoutEdicaoService,
    private router: Router,
    public featureFlagService: FeatureFlagService,
  ) {
    this.layoutEditorContentService.definirIconeAtivo(IconeAtivo.FINANCEIRO);
    this.layoutEditorContentService.definirExibirResultado(true);
    this.layoutEditorContentService.definirExibirBotaoAnterior(false);
    this.layoutEditorContentService.definirRotaAnterior('');
    this.layoutEditorContentService.definirExibirBotaoProximo(false);
    this.layoutEditorContentService.definirRotaProximo('');
  }

  async ngOnInit(): Promise<void> {
    // Configurar informações de localização no layout
    this.configurarInformacoesLocalizacao();

    this.memoriaDeCalculoRequest = {
      diagnosticoDeMatriculaPorEscola:
        this.acessoOfertaEducacionalStateService.getProjecoesOfertaMatriculas(),
      pqrNumeroDiasLetivosList:
        this.condicaoQualidadeStateService.getPQRNumeroDiasLetivosValores(),
      pqrCargaHorariaEnsinosList:
        this.condicaoQualidadeStateService.getPQRCargaHorarioEnsinoValores(),
      pqrTamanhoTurmaList:
        this.condicaoQualidadeStateService.getPQRTamanhoTurmasValores(),
      pqrTamanhoMinimoTurmaList:
        this.featureFlagService.funcionalidadeHabilitada('1104-creche-idade') &&
        this.featureFlagService.funcionalidadeHabilitada(
          '1108-pqr-minimo-turma',
        )
          ? this.condicaoQualidadeStateService.getPQRMinimoTurmasValores()
          : undefined,
      pqrFormacaoJornadaRemuneracaoProfessoresList:
        this.condicaoQualidadeStateService.getPQRFormacaoJornadaRemuneracaoProfessoresValores(),
      pqrQuadroFuncionariosRemuneracaoList:
        this.condicaoQualidadeStateService.getPQRQuadroFuncionariosRemuneracaoValores(),
      pqrManutencaoFormacaoMaterialList:
        this.condicaoQualidadeStateService.getPQRManutencaoFormacaoMaterialValores(),
      pqrAlimentacaoEscolarList:
        this.condicaoQualidadeStateService.getPQRAlimentacaoEscolarValores(),
      pqrEncargosSociaisList:
        this.precoEncargosAdicionaisStateService.getPQREncargosSociaisValores(),
      pqrAdicionaisList:
        this.precoEncargosAdicionaisStateService.getPQRAdicionaisValores(),
      overridesNovasConstrucoes:
        this.condicaoQualidadeStateService.getPqrQuantidadeNovasConstrucoesValores(),
      pqrFatorPonderacaoList:
        this.condicaoQualidadeStateService.getPQRFatorPonderacaoValores(),
    };

    await Promise.all([
      this.dadoFinanceiroService
        .buscarDadoFinanceiro()
        .then((dadosFinanceiros) => (this.dadosFinanceiros = dadosFinanceiros)),
      this.dadosEstatisticosService
        .getDadosEstatisticos()
        .then(
          (dadosEstatisticos) => (this.dadosEstatisticos = dadosEstatisticos),
        ),
      this.funcionariosPorAreaAtuacaoService
        .buscaFuncionariosPorAreaAtuacao()
        .then(
          (funcionariosPorAreaAtuacao) =>
            (this.funcionariosPorAreaAtuacao = funcionariosPorAreaAtuacao),
        ),
      this.memoriaDeCalculoService
        .recalcularMemoriaDeCalculo()
        .then((memoriaDeCalculo) => (this.memoriaDeCalculo = memoriaDeCalculo)),
    ]);
  }

  private configurarInformacoesLocalizacao(): void {
    const localizacaoSelecionada =
      this.localizacaoService.obterLocalizacaoSelecionada();

    if (localizacaoSelecionada) {
      const nomeCompleto = this.localizacaoService.obterNomeLocalizacao(
        localizacaoSelecionada,
      );

      // Definir informações no layout resultado
      this.layoutResultadoService.setPais('Brasil');

      if (localizacaoSelecionada.estadoSelecionado) {
        this.layoutResultadoService.setEstado(
          localizacaoSelecionada.estadoSelecionado.label,
        );
      }

      if (localizacaoSelecionada.cidadeSelecionada) {
        this.layoutResultadoService.setCidade(
          localizacaoSelecionada.cidadeSelecionada.label,
        );
      }

      // Configurar rota para voltar à seleção de local
      this.layoutResultadoService.setRotaFiltroLocalidade('/selecionar-local');
      this.layoutResultadoService.setRotaEdicaoSimulacao('/selecionar-local');
    } else {
      // Definir valores padrão
      this.layoutResultadoService.setPais('Brasil');
      this.layoutResultadoService.setEstado('Nível Nacional');
      this.layoutResultadoService.setCidade('');
      this.layoutResultadoService.setRotaFiltroLocalidade('/selecionar-local');
      this.layoutResultadoService.setRotaEdicaoSimulacao('/selecionar-local');
    }
  }

  get mostrarRpebAposVaat(): boolean {
    return this.featureFlagService.funcionalidadeHabilitada('1214-alteracoes-valor-aluno');
  }

  calcularVariacao(projecao: number, valorAtual: number): number {
    return projecao - valorAtual;
  }

  calcularComplementacao(projecao: number, receita: number): number {
    if (projecao > receita) return projecao - receita;
    return 0;
  }

  calcularTotalNumeroFuncionarios(): number {
    let total = 0;

    this.funcionariosPorAreaAtuacao?.forEach((funcionario) => {
      total += funcionario.quantidade;
    });

    return total;
  }

  porcentagemDoValor(valor: number, total: number): string {
    return maskitoTransform(String((valor / total) * 100), mask_porcetagem);
  }

  formatarDinheiro(valor: number): string {
    return maskitoTransform(String(valor), mask_dinheiro);
  }

  obterDespesaCorrenteAno(): number {
    if (!this.memoriaDeCalculo) return 0;
    return (
      this.memoriaDeCalculo.resultadoDistribuicaoDespesaPorEtapa
        ?.despesaCorrenteAno || 0
    );
  }

  calcularProjecaoDespesaCreche(): number {
    if (this.memoriaDeCalculo === undefined) return 0;
    const etapa31 = this.memoriaDeCalculo.resultadoDistribuicaoDespesaPorEtapa;
    if (!etapa31) return 0;
    return (
      etapa31.despesaCorrenteAnoCrecheUrbanaParcial +
      etapa31.despesaCorrenteAnoCrecheUrbanaIntegral +
      etapa31.despesaCorrenteAnoCrecheRuralParcial +
      etapa31.despesaCorrenteAnoCrecheRuralIntegral
    );
  }

  calcularProjecaoDespesaPreEscola(): number {
    if (this.memoriaDeCalculo === undefined) return 0;
    const etapa31 = this.memoriaDeCalculo.resultadoDistribuicaoDespesaPorEtapa;
    if (!etapa31) return 0;
    return (
      etapa31.despesaCorrenteAnoPreEscolaUrbanaParcial +
      etapa31.despesaCorrenteAnoPreEscolaUrbanaIntegral +
      etapa31.despesaCorrenteAnoPreEscolaRuralParcial +
      etapa31.despesaCorrenteAnoPreEscolaRuralIntegral
    );
  }

  calcularProjecaoDespesaEFAnosIniciais(): number {
    if (this.memoriaDeCalculo === undefined) return 0;
    const etapa31 = this.memoriaDeCalculo.resultadoDistribuicaoDespesaPorEtapa;
    if (!etapa31) return 0;
    return (
      etapa31.despesaCorrenteAnoEnsFunAnosIniciaisUrbanaParcial +
      etapa31.despesaCorrenteAnoEnsFunAnosIniciaisUrbanaIntegral +
      etapa31.despesaCorrenteAnoEnsFunAnosIniciaisRuralParcial +
      etapa31.despesaCorrenteAnoEnsFunAnosIniciaisRuralIntegral
    );
  }

  calcularProjecaoDespesaEFAnosFinais(): number {
    if (this.memoriaDeCalculo === undefined) return 0;
    const etapa31 = this.memoriaDeCalculo.resultadoDistribuicaoDespesaPorEtapa;
    if (!etapa31) return 0;
    return (
      etapa31.despesaCorrenteAnoEnsFunAnosFinaisUrbanaParcial +
      etapa31.despesaCorrenteAnoEnsFunAnosFinaisUrbanaIntegral +
      etapa31.despesaCorrenteAnoEnsFunAnosFinaisRuralParcial +
      etapa31.despesaCorrenteAnoEnsFunAnosFinaisRuralIntegral
    );
  }

  calcularProjecaoDespesaEM(): number {
    if (this.memoriaDeCalculo === undefined) return 0;
    const etapa31 = this.memoriaDeCalculo.resultadoDistribuicaoDespesaPorEtapa;
    if (!etapa31) return 0;
    return (
      etapa31.despesaCorrenteAnoEnsMedioUrbanaParcial +
      etapa31.despesaCorrenteAnoEnsMedioUrbanaIntegral +
      etapa31.despesaCorrenteAnoEnsMedioRuralParcial +
      etapa31.despesaCorrenteAnoEnsMedioRuralIntegral
    );
  }

  calcularProjecaoDespesaEJA(): number {
    if (this.memoriaDeCalculo === undefined) return 0;
    const etapa31 = this.memoriaDeCalculo.resultadoDistribuicaoDespesaPorEtapa;
    if (!etapa31) return 0;
    return (
      etapa31.despesaCorrenteAnoEJAUrbanaParcial +
      etapa31.despesaCorrenteAnoEJARuralParcial
    );
  }
}
